export default __webpack_public_path__ + "static/media/p-avatar.259337f7.png";